import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type WarehouseCredentialRecord = QueryAtomResult<
  typeof warehouseCredentialQueryAtom
>['entries'][number];

export const warehouseCredentialQueryAtom = createQueryAtomFactory(
  'admin.warehouseCredentials',
  () => ({
    warehouseCredentials: {
      __args: {
        pagination: { limit: 1, offset: 0 },
      },
      entries: {
        id: true,
        databaseName: true,
        username: true,
        host: true,
        port: true,
        ssl: true,
        enabled: true,
        timestamps: { createdAt: true, updatedAt: true },
      },
    },
  }),
  {
    select: ({ warehouseCredentials }) => ({
      entries: warehouseCredentials.entries,
    }),
  },
);
